import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconFacebook: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12.94 18v-5.48h1.87l.3-2.1h-2.17V9c0-.6.15-1 1.05-1h1.12V6.08c-.11 0-.82-.08-1.57-.08a2.58 2.58 0 0 0-2.78 2.85v1.57H8.89v2.1h1.87V18z"
    ></path>
  </Svg>
)
